/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 14:18:07
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-06 21:51:33
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC/index.tsx
 */
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { store } from 'src/store';

import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { IParams } from 'src/pages/SalesChannelContentEditor/common';
import RouteBlock from './RouteBlock';
//import { SALES_CHANNELS_MULTI_LANG_PROPS } from 'src/tools/constant';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { currentSelectedSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { ChannelType, WebSiteSubType } from 'src/types/common/SalesChannel';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const BasicPageHOC = (Component: any, obj) => {
  const {
    getState,
    convertDataFromReduxToServer,
    submit,

    getHasModified,
    getSalesChannel,
    getSalesChannelName,
    validation,
    baseURL,
    getLoaded,
    hasRouteBlock,
    queryData,
    siteStyleInParams,
    previewSizeInParams,
    beforeRequest,
    canSaveGenerate,
    beforeSubmitNeedDispatch,
    //beforeSubmit,
    //testFunction,
  } = obj;

  const WrappedComponent = (props) => {
    const type = useSalesChannelType();
    const isNotMini = type !== ChannelType.MiniProgram;
    const salesChannelMultiLanguageParams = {
      [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
      [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
      ...(siteStyleInParams && isNotMini
        ? {
            [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
            [EnumSalesChannelMultiLanguage.siteStyleForceUpdate]: true,
          }
        : {}),
      ...(previewSizeInParams && isNotMini
        ? { [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true }
        : {}),
    };

    const salesChannelMultiLanguageQueryParams = {
      [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
      ...(siteStyleInParams && isNotMini
        ? {
            [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
          }
        : {}),
      ...(previewSizeInParams && isNotMini
        ? { [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true }
        : {}),
      //  salesChannelMultiLanguageUpdate: true,
    };
    // const multiProps = props[SALES_CHANNELS_MULTI_LANG_PROPS];
    // useGetPageLanguageList(multiProps);
    const currentLanguage = useQueryLanguageListContentEditor();
    const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());
    const currentStyle = isNotMini
      ? useSelector(currentSelectedStyle())
      : WebSiteSubType.NativeMobile;

    const currentSize = previewSizeInParams
      ? useSelector(currentSelectedSize())
      : null;
    // console.log('previewSizeInParams', previewSizeInParams);
    //console.log('currentSize', currentSize);
    const _d = useDispatch();
    const _history = useHistory();
    const _params: IParams = useParams();

    const { saleChannelUuid } = _params;
    React.useEffect(() => {
      if (queryData) {
        if (beforeRequest) {
          beforeRequest();
        }
        queryData(_params, salesChannelMultiLanguageQueryParams, _history);
      }
    }, [currentLanguage, currentStyle, currentSize]); //每次变化重新抓取数据
    const hasModified = useSelector(getHasModified());
    const salesChannel = useSelector(getSalesChannel());
    // const status = get(salesChannel, 'status');
    // const uuid = get(salesChannel, 'uuid');

    const canSave = canSaveGenerate ? canSaveGenerate(salesChannel) : true;

    const salesChannelName = useSelector(getSalesChannelName());
    const _l: { loaded: boolean } = getLoaded
      ? useSelector(getLoaded())
      : { loaded: true };
    const { loaded } = _l;
    // console.log('getLoaded', getLoaded);
    // console.log('loaded11', loaded);

    const _getState = () => {
      const _state = store.getState();
      return getState()(_state);
    };
    const _submit = (state) => {
      if (beforeSubmitNeedDispatch) {
        _d(beforeSubmitNeedDispatch());
      }
      const _data = convertDataFromReduxToServer(state, {
        breakpoint: currentSize,
        currentStyle,
      });
      _d(
        submit({
          body: _data,
          params: salesChannelMultiLanguageParams,
          isPrimary: isOnPrimaryLanguage,
          urlParams: _params,
        }),
      );
    };

    const submitData = () => {
      // if (beforeSubmit) {
      //   beforeSubmit();
      // }
      // _d(validation({ isPrimary: isOnPrimaryLanguage }));
      // const _s = _getState();
      // const { isDataValid } = _s;
      // //console.log('isDataValid', isDataValid);
      // return {
      //   submitFunction: () => {
      //     _submit(_s);
      //   },
      //   isDataValid,
      // };

      // return setTimeout(() => {
      _d(validation({ isPrimary: isOnPrimaryLanguage }));
      const _s = _getState();
      const { isDataValid } = _s;
      return {
        submitFunction: () => {
          _submit(_s);
        },
        isDataValid,
      };
      // }, 200);
    };
    const onDiscard = () => {
      _history.push(
        baseURL
          ? `${baseURL}${saleChannelUuid}`
          : `/salesChannel/content/${saleChannelUuid}`,
      );
    };

    const onGoBack = () => {
      _history.push(
        baseURL
          ? `${baseURL}${saleChannelUuid}`
          : `/salesChannel/content/${saleChannelUuid}`,
      );
    };
    const returnProps = {
      onDiscard,
      onGoBack,
      submitData,
      hasModified: hasModified && canSave,
      salesChannel,
      salesChannelName,
      loaded,
      isOnPrimaryLanguage,
      currentStyle,
      currentSize,
      isMini: !isNotMini,
      ...props,
    };
    return (
      <React.Fragment>
        {hasRouteBlock && <RouteBlock hasModified={hasModified} />}
        <Component {...returnProps} />
      </React.Fragment>
    );
  };
  return WrappedComponent;
};
export default BasicPageHOC;
